<user-dropdown>
  <div class="dropdown">
    <button class="btn btn-light dropdown-toggle d-flex align-items-center" type="button" id="userMenuDropdown"
      data-bs-toggle="dropdown" aria-expanded="false">
      <i class="bi bi-person-circle me-2"></i>
      <span>{ state.username || 'Usuario' }</span>
      <span if={ isAdmin() } class="badge bg-danger ms-2">Admin</span>
    </button>
    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userMenuDropdown">
      <li class="dropdown-item-text text-muted">
        <small>Conectado como:</small>
        <div class="fw-bold">{ state.email || 'Usuario' }</div>
      </li>
      <li>
        <hr class="dropdown-divider">
      </li>
      <li><a class="dropdown-item" href="#" onclick={ handleMyProfile }>
        <i class="bi bi-person me-2"></i>Mi Perfil
      </a></li>
      <li>
        <hr class="dropdown-divider">
      </li>
      <li><a class="dropdown-item text-danger" href="#" onclick={ handleLogout }>
        <i class="bi bi-box-arrow-right me-2"></i>Cerrar Sesión
      </a></li>
    </ul>
  </div>

  <script>
    import { AuthService } from '../services/api-service';

    export default {
      onBeforeMount() {
        this.state = {
          username: '',
          email: '',
          roles: []
        };
      },

      onMounted() {
        // Get user data from AuthService
        const userData = AuthService.getUserData();
        if (userData) {
          this.update({
            username: userData.username || '',
            email: userData.email || '',
            roles: userData.roles || []
          });
        }
      },

      isAdmin() {
        return this.state.roles.includes('admin') || AuthService.isAdmin();
      },

      handleLogout(e) {
        e.preventDefault();
        if (this.props.onlogout) {
          this.props.onlogout();
        }
      },

      handleMyProfile(e) {
        e.preventDefault();
        window.history.pushState({}, '', '/profile');
        window.dispatchEvent(new PopStateEvent('popstate'));
      }
    }
  </script>

</user-dropdown>
